import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const PartnersList = ({ partners, conferenceLink }) => {
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : ''
  return (
    <div className="p-4 mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {partners.map((partner) => {
        const utmUrl = `${partner.data.Company_Url}?utm_campaign=${conferenceLink}&utm_medium=website&utm_source=uxdx&utm_content=${encodeURIComponent(currentPath)}`
        // const banner = partner.data.Company_Banner?.localFiles?.[0]?.childImageSharp?.gatsbyImageData
        // const image = getImage(banner)
        //FIXME: Remove bg plugin
        //
        // if (banner) {
        //   return (
        //     <Link
        //       to={conferenceLink + '/partners/' + partner.data.Company_Url_Slug}
        //       key={partner.id}
        //       className="h-48 md:h-72 lg:h-64 xl:h-72"
        //     >
        //       <BgImage image={image} className="w-full h-full rounded-md lg:rounded-lg overflow-hidden">
        //         <div className="p-4 flex flex-col justify-between h-full bg-gradient-to-t from-gray-700 via-transparent to-transparent">
        //           {partner.data.Company_Logo_Url && (
        //             <div className="bg-white rounded-md p-2 w-16 h-16 md:w-32 md:h-32 flex content-center">
        //               <img
        //                 src={partner.data.Company_Logo_Url}
        //                 alt={partner.data.Company_Name + ' Logo'}
        //                 className="mx-auto"
        //               />
        //             </div>
        //           )}
        //           {!partner.data.Company_Logo_Url && <div />}
        //           <p className="text-white text-lg font-bold text-shadow-md">{partner.data.Company_Name}</p>
        //         </div>
        //       </BgImage>
        //     </Link>
        //   )
        // }

        return (
          // <Link
          //   to={conferenceLink + '/partners/' + partner.data.Company_Url_Slug}
          //   key={partner.id}
          //   className=""
          // >
          //   <div className=" p-4 flex items-center h-full">
          //     {partner.data.Company_Logo_Url && (
          //       <div className="bg-white rounded-md p-2 w-48 h-20 flex content-center items-center">
          //         <img src={partner.data.Company_Logo_Url} alt={partner.data.Company_Name + ' Logo'} />
          //       </div>
          //     )}
          //   </div>
          // </Link>
          <a href={utmUrl} key={partner.id} className="" target="_blank" rel="noreferrer">
            <div className=" p-4 flex items-center h-full">
              {partner.data.Company_Logo_Url && (
                <div className="bg-white rounded-md p-2 w-48 h-20 flex content-center items-center">
                  <img src={partner.data.Company_Logo_Url} alt={partner.data.Company_Name + ' Logo'} />
                </div>
              )}
            </div>
          </a>
        )
      })}
    </div>
  )
}

PartnersList.propTypes = {
  partners: PropTypes.array.isRequired,
  conferenceLink: PropTypes.string.isRequired,
}
export default PartnersList
